export default "__VITE_ASSET__Bl08u8Tl__"